import { inject } from "@angular/core";
import { ResolveFn } from "@angular/router";
import { SubscriptionResponse } from "@app/shared/models/subscription/subscription-response.model";
import * as fromRoot from "@app/store";
import { Store } from "@ngrx/store";
import { catchError, EMPTY, Observable, tap, throwError } from "rxjs";
import { UsersService } from "../services/users.service";

export const subscriptionResolver: ResolveFn<
  any
> = (): Observable<SubscriptionResponse> => {
  const usersService = inject(UsersService);

  const store = inject(Store<fromRoot.State>);

  return usersService.loadUserSubscription().pipe(
    tap((subscription) => {
      const { data } = subscription;

      store.dispatch(fromRoot.loadUserSubscriptionSuccess({ data }));
    }),
    catchError((error) => {
      fromRoot.loadUserSubscriptionFailure(error);

      return throwError(() => EMPTY);
    }),
  );
};
